import Page from "../../components/Page";
import useAssessmentPage from "./hooks/useAssessmentPage";

const AssessmentPage = () => {
  const page = useAssessmentPage();
  return <Page {...page}/>;
};

export default AssessmentPage;
